<template>
  <div class="approval-form-config">
    <div class="afc-status">
      <span class="afc-status-label" :class="{ 'is-empty': !hasForm }">
        <i :class="hasForm ? 'el-icon-circle-check afc-icon-ok' : 'el-icon-warning-outline afc-icon-empty'"></i>
        {{ hasForm ? '已配置审批表单' : '未配置审批表单' }}
      </span>
      <div class="afc-actions">
        <el-button size="mini" icon="el-icon-brush" type="primary" plain round @click="open">
          {{ hasForm ? '编辑' : '配置' }}
        </el-button>
        <el-button v-if="hasForm" size="mini" icon="el-icon-delete" type="danger" plain round @click="clear">清除</el-button>
      </div>
    </div>

    <DataGridDialog :visible.sync="visible"
                    title="表单配置"
                    use-fullscreen
                    width="90%"
                    custom-class="approval-form-config-dialog"
                    :close-on-click-modal="false"
                    @open="onOpen">
      <div class="afc-designer-wrap">
        <FormDesigner ref="designer" />
      </div>
      <template slot="footer">
        <el-button @click="visible = false">关闭窗口</el-button>
        <el-button type="primary" @click="finish">完成设计</el-button>
      </template>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../grid/DataGridDialog'
import FormDesigner from '../../../form/FormDesigner'

export default {
  name: 'ApprovalFormConfig',
  components: { DataGridDialog, FormDesigner },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    hasForm () {
      if (!this.value) return false
      try {
        const parsed = JSON.parse(this.value)
        return parsed.rule && parsed.rule.length > 0
      } catch (e) {
        return false
      }
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    onOpen () {
      this.$nextTick(() => {
        const designer = this.$refs.designer
        if (designer && this.value) {
          try {
            const parsed = JSON.parse(this.value)
            if (parsed.rule) designer.setRule(parsed.rule)
            if (parsed.option) designer.setOption(parsed.option)
          } catch (e) {}
        }
      })
    },
    finish () {
      const designer = this.$refs.designer
      if (designer) {
        const rule = designer.getRule()
        const option = designer.getOption()
        this.$emit('input', rule && rule.length ? JSON.stringify({ rule, option }) : '')
      }
      this.visible = false
    },
    clear () {
      this.$confirm('确定要清除审批表单配置吗？', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('input', '')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.approval-form-config {
  border: 1px solid #dcdfe6;
  background-color: #F3F5F7;
  border-radius: 6px;
  overflow: hidden;

  .afc-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;

    .afc-status-label {
      font-size: 13px;
      font-weight: 500;
      display: inline-flex;
      align-items: baseline;
      gap: 6px;
      color: #67c23a;

      &.is-empty {
        color: #909399;
      }

      .afc-icon-ok {
        color: #67c23a;
        font-size: 14px;
      }

      .afc-icon-empty {
        color: #c0c4cc;
        font-size: 14px;
      }
    }

    .afc-actions {
      display: flex;
      gap: 6px;
    }
  }
}
.approval-form-config-dialog {
  margin-top: 5vh !important;

  .el-dialog__body {
    padding: 0;
    height: 80vh;
  }

  .afc-designer-wrap {
    position: absolute;
    inset: 0;

    ._fc-designer {
      height: 100%;
    }
  }
}
</style>
